import gql from 'graphql-tag'

export const PAPER_CHECK = gql`
  mutation PaperCheck($request: PaperCheckInput!) {
    paperCheck(request: $request) {
      paperId
      sentences {
        id
        position {
          length
          offset
        }
      }
    }
  }
`

export const SENTENCE_CHECK = gql`
  mutation SentenceCheck($request: SentenceCheckInput!) {
    sentenceCheck(request: $request) {
      isSuccess
    }
  }
`

export const GET_PAPER = gql`
  query GetPaper($paperId: UUID!) {
    getPaper(paperId: $paperId) {
      title
      status
      requiresReCheck
      paperId
      paperContent
      feedbackState {
        sentences {
          position {
            offset
            length
          }
          id
        }
        initialFeedbackCount
        feedbackList {
          id
          sentenceId
          feedbackType
          reason
          changeType
          position {
            length
            offset
          }
          suggestedText
        }
      }
      createdAt
    }
  }
`

export const GET_PAPER_LIST = gql`
  query GetPaperList($before: String, $after: String) {
    getPaperList(before: $before, after: $after) {
      papers {
        paperId
        title
        status
      }
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
      }
    }
  }
`

export const FEEDBACK_REASON = gql`
  query FeedbackReason($request: FeedbackReasonInput!) {
    feedbackReason(request: $request) {
      isSuccess
    }
  }
`

export const CREATE_PROOF_READER_PAPER = gql`
  mutation CreateProofReaderPaper($request: CreateProofReaderPaperInput!) {
    createProofReaderPaper(request: $request) {
      paperId
    }
  }
`

export const UPDATE_PROOF_READER_PAPER = gql`
  mutation UpdateProofReaderPaper($request: UpdateProofReaderPaperInput!) {
    updateProofReaderPaper(request: $request) {
      isSuccess
    }
  }
`

export const SPLIT_TEXT_INTO_SENTENCES = gql`
  query SplitTextIntoSentences($paperText: String!, $paperId: UUID) {
    splitTextIntoSentences(paperText: $paperText, paperId: $paperId) {
      paperId
      sentences {
        id
        position {
          length
          offset
        }
      }
    }
  }
`
